import { ResultType } from '@/enums';
import { Job, Product } from '@/interfaces/job';
import {
  CREATE_CUSTOM_JOB,
  PermissionString,
  READ_PLATFORM_JOBS,
} from '@/utils/permissions';

type HasPermission = (permission: PermissionString) => boolean;

const INTERNAL_RESULT_TYPES: ReadonlySet<ResultType> = new Set([
  ResultType.MWMINE_FEATURES,
]);

const canSeeInternalJobs = (hasPermission: HasPermission): boolean =>
  // Must be a platform admin or able to create custom jobs
  hasPermission(READ_PLATFORM_JOBS) || hasPermission(CREATE_CUSTOM_JOB);

/** Whether a job or product is intended only for internal users to see. */
export const isInternal = (item: Job | Product): boolean =>
  !!item.result_type && INTERNAL_RESULT_TYPES.has(item.result_type);

/** Filter out jobs and products intended only for internal users to see. */
export function filterInternalResultTypesForUser<T extends Job | Product>(
  items: T[],
  hasPermission: HasPermission
): T[] {
  if (canSeeInternalJobs(hasPermission)) {
    return items;
  }
  return items.filter((item) => !isInternal(item));
}
